export const FC_STALL_MESSAGE_PREFIX = 'Still rendering — processing complex frames';

export interface FcStallProgress {
  showElapsed: boolean;
  stepStartedAt?: number;
}

export function parseFcStallProgress(data?: string, stepElapsedSeconds?: number): FcStallProgress | null {
  if (typeof stepElapsedSeconds === 'number') {
    return { showElapsed: true, stepStartedAt: Date.now() - stepElapsedSeconds * 1000 };
  }

  if (data?.startsWith(FC_STALL_MESSAGE_PREFIX)) return { showElapsed: false };

  return null;
}

export function formatFcStallElapsed(stepStartedAt: number): string {
  const totalSeconds = Math.max(0, Math.floor((Date.now() - stepStartedAt) / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${FC_STALL_MESSAGE_PREFIX} (${minutes}m ${seconds}s on current step)`;
}
